export default __webpack_public_path__ + "static/onsmak-974cbdbbdc2e4711db17635c2691e293.png";